import { z } from 'zod';

import { type BaseItem } from '../common.js';
import { oneOrMany } from '../utils.js';

export enum FlowRunFleetKind {
  Scenario = 'Scenario',
  EventTrigger = 'EventTrigger',
  BulkTestUpload = 'BulkTestUpload',
  Flow = 'Flow',
}

export interface BaseFlowRunFleet {
  kind: FlowRunFleetKind;
  kindId: string;
  organizationId: string;
  maxFlowRunsPerMinute: number | null;
}

export interface FlowRunFleet extends BaseFlowRunFleet, BaseItem {}

export const FindAllSchema = z.object({
  id: oneOrMany(z.string()).optional(),
  organizationId: oneOrMany(z.string()).optional(),
  kind: z.nativeEnum(FlowRunFleetKind).optional(),
  kindId: z.string().uuid().optional(),
  limit: z.coerce.number().optional(),
  offset: z.coerce.number().optional(),
  orderBy: z.string().optional(),
  orderDirection: z.enum(['asc', 'desc']).optional(),
});
export type FindAllArgs = z.infer<typeof FindAllSchema>;
